module.exports = __webpack_public_path__ + "static/media/H5syfc.b2df9f36.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/activity/FloatCouponSpecial/images/H5syfc.png
// module id = 1840
// module chunks = 6